<template>
  <div class="partsrequest">
          This function is in pilot. You will only be able to order parts for your company. Please submit feedback in the survey!
    <Fieldset class="p-shadow-8">

      <template #legend>
        <Dropdown
          class="p-shadow-8"
          v-model="form.bumper"
          :options="admins"
          optionLabel="AdminNo"
          optionValue="AdminNo"
          dataKey="Equipment"
          placeholder="Select a Bumper#"
          :filter="true"
          filterPlaceholder="Find Bumper #"
        />
      </template>
      <b>Create a request for parts!</b>
      <br />
      <InputMask
        type="text"
        class="p-text-uppercase p-m-1"
        style="width: 238px"
        placeholder="Notification #"
        icon="p-input-icon-right"
        mask="99999999999"
        v-model="form.notification"
      />

      <br />

      <InputText
        type="text"
        class="p-text-uppercase p-m-1"
        style="width: 238px"
        placeholder="Part Description"
        icon="p-input-icon-right"
        v-model="form.desc"
      />

      <br />

      <InputMask
        type="text"
        class="p-text-uppercase p-m-1"
        style="width: 238px"
        placeholder="Part NIIN"
        icon="p-input-icon-right"
        mask="99-999-9999"
        v-model="form.niin"
      />

      <br />

      <InputText
        type="text"
        class="p-text-uppercase p-m-1"
        style="width: 4rem"
        placeholder="QTY"
        icon="p-input-icon-right"
        v-model="form.qty"
      />
      <!-- <InputText
          type="text"
          class="p-text-uppercase p-m-1"
          style="width: 2rem"
          placeholder="UI"
          icon="p-input-icon-right"
          v-model="form.ui"
        /> -->

      <Button
        @click="addPart()"
        Label="Add to Shopping Cart"
        class="add p-m-2"
        icon="pi pi-plus"
      />

      <div>
        <hr class="rounded" />
        <div>
          <label>Shopping Cart</label>
          <br />

          <div class="part" v-for="(p, index) in parts" :key="index">
            <h4>{{ p.bumper }}</h4>
            <!-- <h6>{{ p.notification }}</h6> -->
            <h4>{{ p.qty }}ea</h4>
            <p>{{ p.desc }}</p>
            <p>{{ p.niin }}</p>
            <p>{{ p.ui }}</p>

            <Button icon="pi pi-trash" @click="removePart(index)" />
          </div>
          <p v-show="parts.length < 1"><b>No parts yet -- add one!</b></p>
          <br />

          <Button
            type="button"
            label="Submit Your Requests"
            icon="pi pi-plus-circle"
            class="p-button-warning p-mr-3"
            @click="sendPartstodb()"
          />
        </div>
      </div>
    </Fieldset>
    <br />

    <Toast position="bottom-center" />
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Fieldset from "primevue/fieldset";
import Dropdown from "primevue/dropdown";
import { fb_auth, fb_storage, fb_db } from "../firebase";
import InputMask from "primevue/inputmask";

export default {
  name: "PartsRequest",
  components: {
    Dropdown,
    Fieldset,
    InputText,
    InputMask,
  },

  data() {
    return {
      form: {
        bumper: null,
        notification: null,
        desc: null,
        niin: null,
        qty: null,
        ui: null,
        status: null,
      },
      parts: [],
    };
  },

  async mounted() {
    await this.$store.dispatch("getAdmins");
  },

  methods: {
    onUpload(e) {
      console.log("Uploading file....", e.files);
      this.uploading = true;
      let file = e.files[0];
      var uploadTask = fb_storage.child("uploads/" + file.name).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          this.progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + this.progress + "% done");
        },
        function (error) {
          // Handle unsuccessful uploads
        },
        function () {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log("File available at", downloadURL);
            // update some collection with this url
            fb_db.collection("parts").doc("DVkYRdF9aNCQl2BMVUKS").update({
              image: downloadURL,
            });
            this.uploading = false;
          });
        }
      );
    },
    addPart() {
      if (!this.form.bumper) {
        console.log("no bumper");
        this.$toast.add({
          severity: "warn",
          summary: "No bumper #",
          detail: "Please select a bumper number.",
          life: 3000,
        });
      // } else if (!this.form.notification) {
      //   console.log("no notification");
      //   // toast here
      } else if (!this.form.desc) {
        console.log("no desc");
        // toast here
      } else if (!this.form.niin) {
        console.log("no niin");
      } else if (!this.form.qty) {
        console.log("no qty");
        // toast here
      } else {
        let temp_bumper = this.form.bumper;
        let temp_notification = this.form.notification;
        this.parts.push(this.form);
        this.form = {};
        this.form.bumper = temp_bumper;
        this.form.notification = temp_notification;
      }
    },
    removePart(index) {
      this.parts.splice(index, 1);
    },
    async sendPartstodb() {
      let userRef = fb_db.collection("users").doc(fb_auth.currentUser.uid)
      let userData = await userRef.get()
      let user = userData.data()
      this.parts.forEach((p) => {
        fb_db.collection("parts").add({
          notification: p.notification,
          niin: p.niin,
          desc: p.desc,
          admin: p.bumper,
          created: new Date(),
          qty: p.qty,
          status: "Needs Ordered",
          user: fb_db.collection("users").doc(fb_auth.currentUser.uid),
          puic: user.puic, 
        });
      });
      this.parts = [];
      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "Parts Uploaded.",
        life: 3000,
      });
    },
    logoutUser() {
      fb_auth
        .signOut()
        .then(() => {
          //sign-out successful.
          this.$router.push({ path: "/" });
        })
        .catch(function (error) {
          //an error happened
          console.log(error);
        });
    },
  },
  computed: {
    admins() {
      return this.$store.state.puic_admins;
    },
  },
};
</script>

<style lang="scss" scoped>
.partsrequest {
  color: #999999;

  .part {
    background: #efefef;
    border-radius: 10px;
    margin: 15px;
    padding: 5px;
    width: 400px;
    display: flex;
    justify-content: space-between;
  }
}

.container {
  display: flex;
  justify-content: center;
}

.add {
  height: 30px;
  justify-content: center;
}
</style>